/**
 * P0-DISCOVERY-06 — discrete Creator Studio discovery card.
 * Mounted from PredictionCard (correct vote) and from ShareSheet
 * (after a successful share). No modal, no popup.
 */
import { useEffect } from "react";
import { Link } from "@tanstack/react-router";
import { Clapperboard } from "lucide-react";
import { trackEvent } from "@/lib/audit";

export function CreatorDiscoveryCta({ source }: { source: string }) {
  useEffect(() => {
    void trackEvent("creator_discovery_shown", { source });
  }, [source]);
  return (
    <Link
      to="/creator-studio"
      onClick={() => void trackEvent("creator_discovery_clicked", { source })}
      className="mt-1 flex items-center gap-2 rounded-lg border border-border/60 bg-background/70 px-2 py-1.5 text-[10px] font-bold text-foreground transition hover:bg-background"
    >
      <Clapperboard className="h-3 w-3 text-primary" />
      <span className="flex-1 truncate">🎬 Convierte este momento en clip</span>
      <span className="text-[10px] font-black text-primary">→</span>
    </Link>
  );
}
